import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage(){
  return(
    <div className='min-h-screen w-full flex justify-center items-center bg-black text-white'>
      PAGE NOT FOUND
    </div>
  )
}